import List from 'containers/Recruitments/List';
import Edit from 'containers/Recruitments/Edit';
import Create from 'containers/Recruitments/Create';
import Show from 'containers/Recruitments/Show';

export default { List, Edit, Create, Show };
